'use strict';
import {Infoblock} from './infoblock.js';

export class InfoblockContact extends Infoblock {
	
	constructor(component_id) {
		super(component_id);
		
		this.data = yalwa.v.components[this.id].data;
		
		this.vue_data_vars = {
			revealedNumber: null,
			
			// backend source
			valueFromBE: structuredClone(this.data.value),
			
			// working copy
			value: structuredClone(this.data.value),
			
			// local edits
			newWebsite: '',
			profileEditPhoneNumber: '',
			profileEditPhoneCC: null,
			phoneDropdownOpen: false,
			
			// delete flags
			deletedWebsite: false,
			deletedPhone: false,
			
			country_cc: structuredClone(this.data.country_cc),
			existingPhoneNos: structuredClone(this.data.existingPhoneNos),
			existingWebsite: structuredClone(this.data.existingWebsite),
		};
		
		this.vue_method_vars = {
			
			initialize() {
				this.resetState();
			},
			
			// ------------------------
			// RESET (IMPORTANT)
			// ------------------------
			resetState() {
				this.value = JSON.parse(JSON.stringify(this.valueFromBE));
				
				this.newWebsite = '';
				this.profileEditPhoneNumber = '';
				this.phoneDropdownOpen = false;
				this.deletedWebsite = false;
				this.deletedPhone = false;
			},
			
			// ------------------------
			// DELETE (LOCAL ONLY)
			// ------------------------
			deleteContact(type) {
				if (type === 'website') {
					this.deletedWebsite = true;
					this.value.website = '';
				}
				
				if (type === 'phone') {
					this.deletedPhone = true;
					this.value.phone = {phone_no: 0};
				}
			},
			
			// ------------------------
			// STORED NUMBERS DROPDOWN (DEV-18109)
			// ------------------------
			toggle_phone_dropdown() {
				this.phoneDropdownOpen = !this.phoneDropdownOpen;
			},
			
			select_phone(no) {
				this.profileEditPhoneNumber = no.text;
				this.phoneDropdownOpen = false;
			},
			
			// ------------------------
			// SAVE (ONLY API)
			// ------------------------
			saveIconBoxData() {
				this.is_saving = true;
				
			const website = this.deletedWebsite
				? ''
				: (this.newWebsite || this.value.website || '');
				
				let phonePayload = this.deletedPhone
					? {}
					: {
						phoneCC: this.profileEditPhoneCC,
						profileEditPhoneNumber: this.profileEditPhoneNumber || 0
					};
				
				yalwa.basics.ajaxservice({
					type: 'POST',
					resource: 'profileupdate',
					action: 'update_contact',
					data: {
						website,
						phone: JSON.stringify(phonePayload),
						delete_phone: this.deletedPhone
					},
					include_session: true
				}).then(response => {
					
					if (response.type === 'success') {
						if (response.vip_completion) {
							document.dispatchEvent(new CustomEvent('vip_guide_state', {detail: response.vip_completion}));
						}
						this.valueFromBE = structuredClone(response.value);
						this.resetState();
						this.close();
					}
					
					yalwa.basics.toast({
						message: response.label,
						type: response.type
					});
				}).finally(() => {
					this.is_saving = false;
				});
			},
			
			// ------------------------
			// CLOSE (RESET)
			// ------------------------
		close() {
			this.resetState();
			this.closeDialog();
		},
		
		revealNumber(event) {
			// AJAX always fires for server-side Genstat tracking (login_state tracked server-side)
			this.revealPhone().then(response => {
				if (yalwa.basics.is_logged_in()) {
					yalwa.basics.ga.event({ category: 'reveal_number_profile', action: 'logged_in' });
					if (response && response.success && response.number) {
						this.revealedNumber = response.number;
					}
				} else {
					yalwa.basics.ga.event({ category: 'reveal_number_profile', action: 'logged_out' });
					yalwa.basics.ss_set('profile_reveal', true);
					yalwa.mobile.auth.show_dialog(event);
				}
			});
		},
		
		revealPhone() {
			const phone = this.value.phone;
			if (!phone.c || !phone.k) {
				return Promise.resolve(null);
			}
			return yalwa.basics.ajaxservice({
				type: 'POST',
				resource: 'posting',
				action: 'reveal_phone',
				csrf: phone.csrf,
				identifier: phone.userID,
				data: {
					c: phone.c,
					k: phone.k,
					call_button: 'profile_reveal'
				},
				include_session: true,
				is_cross_origin: true
			});
		},
		
		callNumber() {
			if (!this.revealedNumber) {
				return;
			}
			const phone = this.value.phone;
			yalwa.basics.ga.event({ category: 'profile_call', action: 'logged_in' });
			// Genstat tracking via same endpoint as VAP/BST (call_button triggers server-side tracking)
			yalwa.basics.ajaxservice({
				type: 'POST',
				resource: 'posting',
				action: 'reveal_phone',
				csrf: phone.csrf,
				identifier: phone.userID,
				data: {
					c: phone.c,
					k: phone.k,
					call_button: 'profile_call'
				},
				include_session: true,
				is_cross_origin: true
			});
			yalwa.basics.navigate('tel:' + this.revealedNumber);
		}
		};
		
		this.extras = {
			computed: {
				
				// ------------------------
				// SAVE BUTTON CONTROL
				// ------------------------
				isUnchanged() {
					
					const current = {
						website: this.deletedWebsite
							? ''
							: (this.newWebsite || this.value.website || ''),
						
						phone: this.deletedPhone
							? ''
							: (this.profileEditPhoneNumber || this.value?.phone?.phone_no || '')
					};
					
					const backend = {
						website: this.valueFromBE?.website || '',
						phone: this.valueFromBE?.phone?.phone_no || ''
					};
					
					return JSON.stringify(current) !== JSON.stringify(backend);
				}
			},
			
		mounted() {
			this.initialize();
			// Focus opening is bound in the template (data-v-focus); only the
			// outside dismissal needs a document listener.
			jQuery(document).off('click.profile_contact_phone_dropdown focusin.profile_contact_phone_dropdown').on('click.profile_contact_phone_dropdown focusin.profile_contact_phone_dropdown', (e) => {
				if (!jQuery(e.target).closest('.phonestoreddropdown').length) {
					this.phoneDropdownOpen = false;
				}
			});
			if (yalwa.basics.ss_get('profile_reveal')) {
				yalwa.basics.ss_remove('profile_reveal');
				this.revealPhone().then(response => {
					if (response && response.success && response.number) {
						this.revealedNumber = response.number;
					}
				});
			}
		},

		unmounted() {
			jQuery(document).off('click.profile_contact_phone_dropdown focusin.profile_contact_phone_dropdown');
		}
		};
	}
	
	setup_vars(Vue) {
		
		this.init_select();
		
		const profileEditPhoneCC = Vue.ref(null);
		
		let country_cc = yalwa.v.components.infoblock_contact.data.country_cc;
		
		const defaultEntry = Object.values(country_cc)
			.find(item => item.selected);
		
		if (defaultEntry) {
			profileEditPhoneCC.value = defaultEntry.value;
		}
		
		const selectedDial = Vue.computed(() => {
			const entry = Object.values(country_cc)
				.find(item => item.value === profileEditPhoneCC.value);
			
			return entry ? entry.dial : '';
		});
		
		return {
			profileEditPhoneCC,
			selectedDial
		};
	}
	
	init_select() {
		jQuery('.js-profile_edit_phone_cc').on('change', (e) => {
			let $this = jQuery(e.currentTarget);
			let $selected = jQuery(this).find('option:selected');
			let short_code = $selected.data('short');
			jQuery($this).parent().find('.js-profile_phone_selected_value_cc').text(short_code);
		});
	}
}
